export default __webpack_public_path__ + "static/media/portrait-env.dd2d43c9.hdr";